.footerContainer{
    width: 95%;
    background-color:#000;
    color: white;
    display: flex;
    flex-direction: column;
    align-items: center;
    padding: 30px;
}

.footer_detail{
    width: 90%;
    display: flex;
    justify-content: space-between;
    padding: 20px;
    border-bottom: 1px solid gray;
}
.item_align{
    align-items: center;
}


.title_name{
    font-weight: bold;
    color: rgb(152, 147, 147);
    margin-bottom: 30px;
    text-align: left;
}

.footer_list{
    list-style-type: none;
    padding: 0px;
    text-align: left;
}
.footer_list li{
    margin-bottom: 10px;
}
.footer_list li a{
    color: white;
    text-decoration: none;
}

.footer_list li a:hover{
text-shadow: 1px 0px 0px rgb(255, 255, 255);
}

.app_store{
    display: flex;
    flex-direction: column;
}

.app_store_img{
    height: 50px;
    width: 150px;
    margin-bottom: 20px;
    transition: 0.6s;
}
.app_store_img:hover
{
    transform: scale(1.1);
    border-radius: 6px;
    box-shadow: 0 0 10px rgba(78, 90, 255, 0.5);
}

.logo img {
    height: 70px;
    width: 70px;
    border-radius: 6px;
    transition: 0.6s;
}

.social_media ul{
    display: flex;
    list-style-type: none;
    padding: 0px;
}

.icon{
    height: 25px;
    width: 25px;
    margin-right: 20px;
    transition: 0.6s;
}

.icon:hover,.logo img:hover{
    transform: scale(1.5);
    border-radius: 6px;
    box-shadow: 0 0 10px rgba(78, 90, 255, 0.5);
}

.site_dev{
    padding: 20px;
    border-bottom: 1px solid gray;
}

.site_dev span{
    color: rgb(0, 225, 255);
}